/**
 * Files API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { deleteFile, getFileById, getFiles, uploadFile } from "../generated/files/files";

import { wrapListMethod, wrapMethod } from "./utils";

export const files = {
  /** @see uploadFile */
  uploadFile: wrapMethod(uploadFile),

  /** @see getFiles */
  list: wrapListMethod(getFiles),

  /** @see getFileById */
  get: wrapMethod(getFileById),

  /** @see deleteFile */
  delete: wrapMethod(deleteFile),
} as const;

export type FilesApi = typeof files;
